<div class="soft-title light mt-3">
  {{ '#WORK_NOTE.QUERY.QUERY.QUICK_LINKS.TITLE' | translate }}
</div>

<div class="g auto-fill mt-2 mb-2 gap">
  <div class="tab bg-surface group hover:bg-hover" (click)="onSubmit(currentWeekQuery)">
    <a class="soft-link hover:!text-color">
      {{ '#WORK_NOTE.QUERY.QUERY.QUICK_LINKS.CURRENT_WEEK' | translate }}
    </a>
  </div>
  <div class="tab bg-surface hover:bg-hover" (click)="onSubmit(lastWeekQuery)">
    <a class="soft-link hover:!text-color">
      {{ '#WORK_NOTE.QUERY.QUERY.QUICK_LINKS.LAST_WEEK' | translate }}
    </a>
  </div>
  <div class="tab bg-surface hover:bg-hover" (click)="onSubmit(currentMonthQuery)">
    <a class="soft-link hover:!text-color">
      {{
      '#WORK_NOTE.QUERY.QUERY.QUICK_LINKS.CURRENT_MONTH' | translate
      }}
    </a>
  </div>
  @if (config?.showMusterQuickLink) {
    <div class="tab bg-surface hover:bg-hover" (click)="onShowMuster()">
      <a class="soft-link hover:!text-color">
        {{
        '#WORK_NOTE.QUERY.QUERY.QUICK_LINKS.MUSTER' | translate
        }}
      </a>
    </div>
  }
</div>

<div class="soft-title light mt-5">
  {{ '#WORK_NOTE.QUERY.QUERY.MANUAL' | translate }}
</div>
<ng-container>
  <div class="flex flex-col fill mt-2">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="w-full flex flex-col gap-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex flex-col w-full">
          <label class="soft-label !font-semibold !text-xs left required mb-1">Von</label>
          <soft-date-input formControlName="from"></soft-date-input>
        </div>

        <div class="flex flex-col w-full">
          <label class="soft-label !font-semibold !text-xs left required mb-1">Bis</label>
          <soft-date-input formControlName="to"></soft-date-input>
        </div>
      </div>

      <div class="flex flex-col w-full">
        <label class="soft-label !font-semibold !text-xs left mb-1">Objekt</label>
        <soft-field-ok
          formControlName="object"
          fieldOkName="objekt"
          placeholder="Objekt"
          [parameters]="{ status: 'O' }"
          #convertValue
        ></soft-field-ok>
      </div>
    </form>

    <div class="flex flex-row flex-wrap items-center justify-end gap-2 mt-3 mb-2">
      <soft-ds-button
        variant="ghost"
        data-testid="work-note-query-reset"
        (click)="form.reset()"
      >
        {{ '#WORK_NOTE.QUERY.QUERY.RESET' | translate }}
      </soft-ds-button>
      <soft-ds-button
        variant="primary"
        data-testid="work-note-query-submit"
        [disabled]="form.invalid"
        (click)="onSubmit(form.value)"
      >
        {{ '#WORK_NOTE.QUERY.QUERY.SUBMIT' | translate }}
      </soft-ds-button>
    </div>
  </div>
</ng-container>
